<!--New design-->
<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row">
    <div style="margin-top:15px; margin-bottom:-10px;">
      <h5><span style="padding-right:10px"></span> <i class="fa fa-edit"></i><b> Manage Return of Permits</b></h5>
    </div>
  </div>
  <hr />
    <form [formGroup]="form">

      <label>You can either</label>
        <div class="col-sm-4 ">
          <input type="radio" formControlName="btnRadio" [(ngModel)]="btnRadio"   name="btnRadio" value="A"/>
          <label>Scan QR code OR</label>
        </div>
        <div class="col-sm-4">
          <input type="radio" formControlName="btnRadio" [(ngModel)]="btnRadio"    name="btnRadio" value="B"/>
          <label>Enter permit number and face value number</label>
        </div>
        <div  class="row" *ngIf="btnRadio=='A'">
          <div class="col-sm-4 " >
            <label><b>Under Construction</b></label>
        </div>
        </div>

        <div  class="row" *ngIf="btnRadio=='B'">
        <div class="col-sm-4 " >
          <label>Permit Number</label>
          <input formControlName="permit_num"  class="form-control form-control-sm" type="text"/>
      </div>
        <div class="col-sm-4 ">
            <label>Face Value Number</label>
            <input formControlName="face_value" class="form-control form-control-sm" type="text"/>
        </div>
        <div class="col-sm-4" >
          
          <label>Carrier Name</label>
          <div class="form-inline">
            <input readonly style="width:70%;"  formControlName="carrier_name"  class="form-control form-control-sm" type="text"/>
            <!-- &nbsp;
            <i class="text-success fa fa-search" (click)="search()" aria-hidden="true" ></i> -->
            &nbsp;
            <button class="btn-confirm" (click)="confirm()"><i class="fa fa-check-square-o" aria-hidden="true"></i>
              Confirm</button>
          </div>

          


      </div>
      </div>
    </form>
 
</div> <!--End new design -->
